import { Component, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../auth/services/auth.service';
import { StorageService } from '../../../core/services/storage.service';
import { AlertaService } from '../../../core/services/alerta.service';
import { AppMenu } from '../menu/app.menu.component';


@Component({
    selector: 'app-sidebar',
    templateUrl:'./app.sidebar.component.html',
    styleUrl: './app.sidebar.component.scss',
    imports: [AppMenu]
})
export class AppSidebar {
    constructor(
        public el: ElementRef,
        private readonly authService: AuthService,
        private readonly storageService: StorageService,
        private readonly router: Router,
        private readonly alerta: AlertaService,
    ) {}

    cerrarSesion(): void {
        this.alerta.openAlertaDesicion('Cerrar sesión', '¿Deseas cerrar tu sesión actual?', 'warn', () => this.confirmarCierreSesion());
    }

    private confirmarCierreSesion(): void {
        this.authService.cerrarSesion().subscribe({
            next: () => this.finalizarSesion(),
            error: () => this.finalizarSesion(),
        });
    }

    private finalizarSesion(): void {
        this.storageService.storageClear();
        this.router.navigate(['/auth/login']);
    }
}
